import { AsyncMultiSelectField, Button, CharField, ImageField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { ImmagineAtlanteFormType } from "../../types"
import { WysiwygField } from "../../components/WysiwygField"
import { useRelazioneAtlanteLazy, useRelazioniAtlanteLazy } from "../../hooks/relazioni"

export default function ImmagineAtlanteForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<ImmagineAtlanteFormType>()

  const fetchRelazione = useRelazioneAtlanteLazy()
  const fetchRelazioni = useRelazioniAtlanteLazy()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        labelColSize={2}
        inputColSize={10}
        label="Titolo"
        layout="horizontal"
        value={values.titolo}
        onChange={(value) => {
          setFieldValue("titolo", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "titolo") : undefined}
        errorMessage={getIn(errors, "titolo")}
        required
      />

      <ImageField
        label="Immagine"
        layout="horizontal"
        labelColSize={2}
        inputColSize={10}
        value={values.immagine}
        onChange={(value) => {
          setFieldValue("immagine", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "immagine") : undefined}
        errorMessage={getIn(errors, "immagine")}
        required
      />

      <AsyncMultiSelectField
        label="Relazioni"
        layout="horizontal"
        labelColSize={2}
        inputColSize={10}
        placeholder="Seleziona uno o più relazioni"
        onChange={(value) => {
          setFieldValue("relazioni", value)
        }}
        clearable
        value={values.relazioni || []}
        loadInitialValues={(ids: number[]) =>
          Promise.all(
            ids?.map((id) => fetchRelazione(id).then((relazione) => ({ label: relazione.nome, value: relazione.id })))
          )
        }
        loadOptions={(inputValue: string) => {
          return fetchRelazioni({ search: inputValue }).then((relazioni) => {
            return relazioni.results?.map((relazione) => ({
              label: relazione.nome,
              value: relazione.id,
            }))
          })
        }}
      ></AsyncMultiSelectField>

      <WysiwygField
        label="Descrizione"
        layout="horizontal"
        labelColSize={2}
        inputColSize={10}
        value={values.descrizione}
        onChange={(value) => {
          setFieldValue("descrizione", value)
        }}
      />
    </Col>
  )
}
